import { gsap, Power2 } from 'gsap';
import { breakpointDown } from '../utils/breakpoints'

class PostCard {
  constructor (element) {

    this.element = element
    this.feDisplacementMap = $(element).find('feDisplacementMap')

    this.primitiveValues = { scale: 0 }

    this.timeline = gsap.timeline({
      paused: true,
      defaults: {
        duration: 0.35,
        ease: Power2.easeInOut
      },
      onUpdate: () => this.updateDisplacementMapScale()
    })
    this.timeline.to(this.primitiveValues, {
      startAt: {scale: 0},
      scale: 50
    }, 0);

    this.initEvents()
  }
  initEvents() {

    this.onMouseEnterFn = () => this.mouseEnter();
    this.element.addEventListener('mouseenter', this.onMouseEnterFn);

    this.onMouseLeaveFn = () => this.mouseLeave();
    this.element.addEventListener('mouseleave', this.onMouseLeaveFn);

  }
  updateDisplacementMapScale(val = this.primitiveValues.scale) {
    this.feDisplacementMap.attr('scale', val);
  }
  mouseEnter() {
    this.timeline.restart()
  }
  mouseLeave() {
    this.timeline.reverse()
  }
}

function setupPostCardAnimation()
{
  if (breakpointDown('lg')) return false

  gsap.utils.toArray('.post-card').forEach(element => new PostCard(element))
}

export { setupPostCardAnimation }
